import { ArticleParagraph1 } from '@cian/ui-kit';

import { FC } from 'react';

import { IAddress } from './types';

export const Address: FC<IAddress> = props => {
  const { addressText, className } = props;

  return (
    <div className={className}>
      <ArticleParagraph1>{addressText}</ArticleParagraph1>
    </div>
  );
};

Address.displayName = 'Address';
